import React from 'react';
import { isValid, isValidArray,checkActionAllowed,isValidString } from "../../utils/utilities";
import { TOOLTIP_HIDE_BOOK_INFO_OTHER_USER, getSameUser } from '../../utils/constant';
import { getLocalDateAndTime, getTimeStampInReadableFormat } from '../../utils/date.utils';
import { PhoneFilled } from '@ant-design/icons';
import { roundNumber } from '../../utils/math.utils';

const getDriverName = (ticket_agent_privilege,blocked_by) => {
    if(ticket_agent_privilege == "Driver"){
        return "Driver ("+blocked_by+")";
    }else{
        return blocked_by;
    }
}

const getName = (passenger) => {
    if(isValid(passenger.full_name)&&isValid(passenger.phone_number)){
        return `for ${passenger.full_name} (${passenger.phone_number})`;
    }else if(isValid(passenger.full_name)){
        return `for ${passenger.full_name}`;
    }
    return '';
}


const getBookedName = (passenger,displayStatus) => {

    if(isValid(passenger.traveller_status)){
        displayStatus = passenger.traveller_status;
    }
    let phoneBlock = "";
    if(displayStatus == "Blocked" && isValid(passenger.ticket_id)){
        phoneBlock = 'Phone';
    }
    if(passenger.ticket_agent_privilege == "Driver"){
        return `${phoneBlock}${displayStatus} by ${getDriverName(passenger.ticket_agent_privilege,passenger.agent_name)}`;
    }else{
        if(isValid(passenger.user_name)&&passenger.user_name != passenger.blocked_by){
            return `${phoneBlock}${displayStatus} by ${passenger.user_name}  on behalf of ${passenger.agent_name}`;
        }else{
            const bookedBy = isValid(passenger.agent_name) ? passenger.agent_name : passenger.blocked_by;
            return `${phoneBlock}${displayStatus} by ${bookedBy}`;
        }
    }
}

export const extractPassengerInfo = (passenger, displayStatus) => {
    let pickup = null;

    if(isValid(passenger.pickup_location_name)){
        pickup = passenger.pickup_location_name;
    }else if(passenger.pickup_location){
        pickup = passenger.pickup_location;
    }

    let dropOff = null;
    if(isValid(passenger.drop_location_name)){
        dropOff = passenger.drop_location_name;
    }else if(passenger.drop_location){
        dropOff = passenger.drop_location;
    }
    
    
    const bookedName = getBookedName(passenger, displayStatus);
    const passName = isValid(passenger.full_name)?`Name : ${passenger.full_name}`:'';
    const passPhone = isValid(passenger.phone_number)?`Phone no : ${passenger.phone_number}`:'';
    const gender = passenger.gender ? `Gender: ${passenger.gender}` : '';
    const seatNumber = passenger.seat_number ? `Seat Number: ${passenger.seat_number}` : '';
    let pnr = '';
    if(passenger.traveller_status == "Confirmed"){
        pnr = `PNR: ${passenger.pnr}`;  
    }else if(passenger.traveller_status == "Blocked"){
        pnr = `PNR: Blocked (${passenger.pnr})`;
    }else{
        pnr = '';
    }
    const origin = passenger.origin ? `Origin: ${passenger.origin}` : '';
    const destination = passenger.destination ? `Destination: ${passenger.destination}` : '';
    let pickUp =  pickup ? `Pick up: ${pickup}` : '';
    pickUp += passenger.pickup_timing ? `, ${getTimeStampInReadableFormat(passenger.pickup_timing)}` : '';
    const doj = passenger.doj ? `DOJ: ${passenger.doj}` : '';
    let dropUp = dropOff ? `Drop: ${dropOff}` : '';
    dropUp += passenger.drop_timing ? `, ${getTimeStampInReadableFormat(passenger.drop_timing)}` : '';
    const hasDiscount = passenger.total_discount > 0;
    const grossFare = hasDiscount && passenger.total_discounted_fare ?
        `Total Fare: ${roundNumber(passenger.total_discounted_fare + passenger.total_discount)}` : '';
    const discount = hasDiscount ? `Total Discount: ${roundNumber(passenger.total_discount)}` : '';
    const totalDiscountedFare = passenger.total_discounted_fare ?
        `Total ${hasDiscount ? 'Discounted Fare' : 'Fare'}: ${roundNumber(passenger.total_discounted_fare)}` : '';
    const totalGst = passenger.total_gst ? `Total GST: ${roundNumber(passenger.total_gst)}` : '';
    const totalAmountPaid = passenger.total_amount_paid ? `Total Amount: ${roundNumber(passenger.total_amount_paid)}` : '';
    const paymentType = isValidString(passenger.payment_type) ? `Payment Type: ${passenger.payment_type}` : '';
    const bookingTime = passenger.booking_time ? `${displayStatus} Time: ${getLocalDateAndTime(passenger.booking_time)}` : '';
    const notBoardedBy = isValid(passenger.cancelled_by) ? `Not Boarded by: ${passenger.cancelled_by}` : '';
    const notBoardedTime = isValid(passenger.cancelled_by) && isValid(passenger.cancellation_time) ? `Not Boarded Time: ${getLocalDateAndTime(passenger.cancellation_time)}` : '';
    const remarks = passenger.remarks ? `Remarks: ${passenger.remarks}` : '';
    const rescheduledInfo = passenger.rescheduled_pnr ? `Rescheduled PNR: ${passenger.rescheduled_pnr}` : '';
    const age = passenger.age>0?`Age: ${passenger.age}`:null;
    const otherSeats = isValidArray(passenger.seats_with_same_pnr) && passenger.seats_with_same_pnr.length > 1 ?
        `Other Seats: ${passenger.seats_with_same_pnr.filter(seat => seat !== passenger.seat_number).join(', ')}` : '';
    
    const getTooltipValue = (key, value) => {
        return global.tooltipFieldConfigs && global.tooltipFieldConfigs[key] ? value : null;
    };
    
    return { 
        // Passenger Information Fields
        passName: getTooltipValue('pass_name', passName),
        passPhone: getTooltipValue('pass_phone', passPhone),
        age: getTooltipValue('age', age),
        gender: getTooltipValue('gender', gender),

        // Journey Information Fields
        seatNumber: getTooltipValue('seat_number', seatNumber),
        otherSeats: getTooltipValue('other_seats', otherSeats),
        origin: getTooltipValue('origin', origin),
        destination: getTooltipValue('destination', destination),
        pickUp: getTooltipValue('pickup', pickUp),
        doj: getTooltipValue('doj', doj),
        dropUp: getTooltipValue('drop_off', dropUp),

        // Booking Information Fields
        pnr: getTooltipValue('pnr', pnr),
        bookingTime: getTooltipValue('booking_time', bookingTime),
        bookedName: getTooltipValue('booked_by', bookedName),
        notBoardedBy,
        notBoardedTime,

        // Payment Information Fields
        grossFare: getTooltipValue('total_fare', grossFare),
        discount,
        totalDiscountedFare: getTooltipValue('total_fare', totalDiscountedFare),
        totalGst: getTooltipValue('total_gst', totalGst),
        totalAmountPaid: getTooltipValue('total_amount', totalAmountPaid),
        paymentType,

        // Other Fields
        remarks: getTooltipValue('remarks', remarks),
        rescheduledInfo: getTooltipValue('rescheduled_info', rescheduledInfo)
    };
};

export const getTicketInfoInfo = (object, passengers, displayStatus) => {
    let bookedName = displayStatus, pickUp = '', dropUp = '', grossFare = '', totalDiscountedFare = '', totalGst = '', totalAmountPaid = '' , discount = '', paymentType = '',
    bookingTime = '' , remarks = '',rescheduledInfo = '',origin = '',destination = '',doj = '', otherSeats = '';
    let gender = '';
    let age = '';
    let passName = '';
    let passPhone = '';
    let seatNumber = '',pnr='';        
    if (isValidArray(passengers) && passengers.length >= 1) {
        const passenger = passengers[0];
        let sameInfo = false;
        if (checkActionAllowed(TOOLTIP_HIDE_BOOK_INFO_OTHER_USER)){
            if (getSameUser(passenger.agent_id)){
                sameInfo = true;
            }
            else {
                for (let i = 0; i < passengers.length; i++) {
                    const passInfo = passengers[i];                    
                    if (getSameUser(passInfo.agent_id)){
                        const passengerInfo = extractPassengerInfo(passInfo, displayStatus);
                        bookedName = passengerInfo.bookedName;
                        passName = passengerInfo.passName;
                        passPhone = passengerInfo.passPhone;
                        gender = passengerInfo.gender;
                        age = passengerInfo.age;
                        seatNumber = passengerInfo.seatNumber;
                        pnr = passengerInfo.pnr;
                        origin = passengerInfo.origin;
                        destination = passengerInfo.destination;
                        pickUp = passengerInfo.pickUp;
                        doj = passengerInfo.doj;
                        dropUp = passengerInfo.dropUp;
                        // amountPaid = passengerInfo.amountPaid;
                        grossFare = passengerInfo.grossFare;
                        totalDiscountedFare = passengerInfo.totalDiscountedFare;
                        totalGst = passengerInfo.totalGst;
                        totalAmountPaid = passengerInfo.totalAmountPaid;
                        discount = passengerInfo.discount;
                        bookingTime = passengerInfo.bookingTime;
                        remarks = passengerInfo.remarks;
                        rescheduledInfo = passengerInfo.rescheduledInfo;
                        otherSeats = passengerInfo.otherSeats;
                        break;
                    }
                }
            }
        }
        else {
            sameInfo = true;
        }
        if (sameInfo){
            const passengerInfo = extractPassengerInfo(passenger, displayStatus);
            bookedName = passengerInfo.bookedName;
            passName = passengerInfo.passName;
            passPhone = passenger.passPhone
            gender = passengerInfo.gender;
            age = passengerInfo.age;
            seatNumber = passengerInfo.seatNumber;
            pnr = passengerInfo.pnr;
            origin = passengerInfo.origin;
            destination = passengerInfo.destination;
            pickUp = passengerInfo.pickUp;
            doj = passengerInfo.doj;
            dropUp = passengerInfo.dropUp;
            // amountPaid = passengerInfo.amountPaid;
            grossFare = passengerInfo.grossFare;
            totalDiscountedFare = passengerInfo.totalDiscountedFare;
            totalGst = passengerInfo.totalGst;
            totalAmountPaid = passengerInfo.totalAmountPaid;
            discount = passengerInfo.discount;
            paymentType = passengerInfo.paymentType;
            bookingTime = passengerInfo.bookingTime;
            remarks = passengerInfo.remarks;
            rescheduledInfo = passengerInfo.rescheduledInfo;
            otherSeats = passengerInfo.otherSeats;
        }

    } else {
        let showInfo = true;
        if (checkActionAllowed(TOOLTIP_HIDE_BOOK_INFO_OTHER_USER)){
            if (!getSameUser(object.agent_id)){
                showInfo = false;
            }
        }
        if (showInfo){
            const passengerInfo = extractPassengerInfo(object, displayStatus);
            bookedName = passengerInfo.bookedName;
            passName = passengerInfo.passName;
            passPhone = passengerInfo.passPhone;
            gender = passengerInfo.gender;
            age = passengerInfo.age;
            seatNumber = passengerInfo.seatNumber;
            pnr = passengerInfo.pnr;
            origin = passengerInfo.origin;
            destination = passengerInfo.destination;
            pickUp = passengerInfo.pickUp;
            doj = passengerInfo.doj;
            dropUp = passengerInfo.dropUp;
            // amountPaid = passengerInfo.amountPaid;
            grossFare = passengerInfo.grossFare;
            totalDiscountedFare = passengerInfo.totalDiscountedFare;
            totalGst = passengerInfo.totalGst;
            totalAmountPaid = passengerInfo.totalAmountPaid;
            discount = passengerInfo.discount;
            paymentType = passengerInfo.paymentType;
            bookingTime = passengerInfo.bookingTime;
            remarks = passengerInfo.remarks;
            rescheduledInfo = passengerInfo.rescheduledInfo;
            otherSeats = passengerInfo.otherSeats;
        }   
    }

    return { bookedName,passName,passPhone, gender,pickUp, dropUp, grossFare,totalDiscountedFare,totalGst,totalAmountPaid,discount,paymentType, bookingTime, remarks,rescheduledInfo,origin,destination,seatNumber,pnr , doj,age, otherSeats};
};


export const TooltipContent = ({ bookedName,passName,passPhone, gender,age, pickUp, dropUp, grossFare,totalDiscountedFare,totalGst,totalAmountPaid,discount,paymentType, changeOldLayout , bookingTime, remarks,rescheduledInfo,origin,destination,seatNumber,pnr,doj,passengerNo, otherSeats, notBoardedBy, notBoardedTime}) => {
    let toolTipContent = [];
    if (changeOldLayout) {
        toolTipContent.push(bookedName);
    }
    else {
        toolTipContent.push(passengerNo,bookedName);
        if (isValidString(notBoardedBy)) {
            toolTipContent.push(notBoardedBy, notBoardedTime);
        }
        toolTipContent.push(passName,passPhone);
        if (!isValid(global.travelsAppConfig['HIDE_AGE_FROM_BOOKING'])) {
            toolTipContent.push(age);
        }
        if (!isValid(global.travelsAppConfig['HIDE_GENDER_FROM_BOOKING'])) {
            toolTipContent.push(gender);
        }        
        toolTipContent.push(seatNumber, otherSeats, origin, destination, pickUp,doj, dropUp, bookingTime, grossFare,discount,totalDiscountedFare,totalGst,totalAmountPaid,paymentType, remarks,rescheduledInfo,pnr);
    }
    
    return (
        <div className='passengerDetailsBlock'>
            {toolTipContent.map((item, index) => (
                isValidString(item) && (
                <React.Fragment key={index}>
                    <span>
                        {index == 1 && item.includes("PhoneBlocked")?
                        <span>
                            <PhoneFilled style ={{transform: 'rotate(180deg)',paddingLeft: '5px'}}/>
                            {item.replace("PhoneBlocked", "Blocked")}
                        </span>
                        :item}
                    </span><br />
                </React.Fragment>
            )
        ))}
        </div>
    )
}